import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import ReactCardCarousel from '@homeaway/react-card-carousel';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import {pushEdapEvent} from '../../../utils/edap';
import classNames from 'classnames';

import './Carousel.less';

const DESKTOP_BREAKPOINT = 992;

export function mapStateToProps(state) {
    return {
        deviceType: state.config.deviceType,
    };
}

export class CarouselComponent extends Component {
    static propTypes = {
        cardAspectRatio: PropTypes.string,
        cardIndex: PropTypes.number,
        carouselBreakpoints: PropTypes.shape().isRequired,
        actionlocation: PropTypes.string,
        hasAction: PropTypes.bool,
    };

    static defaultProps = {
        cardAspectRatio: '4x3',
        cardIndex: 0,
        carouselBreakpoints: {
            1100: 5,
            992: 4,
            768: 5,
            640: 4,
            400: 3,
            0: 2,
        },
        hasAction: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            cardIndex: props.cardIndex,
            scrolling: this.shouldScrollOnServerRender(),
        };
    }

    componentDidMount() {
        window.dispatchEvent(new Event('scroll'));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.cardIndex !== this.props.cardIndex) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                cardIndex: this.props.cardIndex,
            });
        }
    }

    getControlOffset = (aspectRatio) => {
        return (width, controlHeight) => {
            return AspectRatioCard.getControlOffset(
                width,
                controlHeight,
                aspectRatio
            );
        };
    };

    getViewportWidth() {
        const docElem = document.documentElement;
        const widths = [
            window.innerWidth,
            docElem.clientWidth,
            docElem.offsetWidth,
            document.body.clientWidth,
        ];
        const screenWidth = window.screen.width;
        let width;

        for (let i = 0; i < widths.length; i++) {
            // If not a number remove it
            if (isNaN(widths[i])) {
                widths.splice(i, 1);
                i--;
            }
        }

        if (widths.length) {
            width = Math.max(...widths);

            // Catch cases where the viewport is wider than the screen
            if (!isNaN(screenWidth)) {
                width = Math.min(screenWidth, width);
            }
        }

        return width || screenWidth || 0;
    }

    shouldScrollOnServerRender() {
        const {deviceType} = this.props;
        return deviceType === 'mobile' || deviceType === 'tablet';
    }

    shouldScrollOnClientRender() {
        return this.getViewportWidth() < DESKTOP_BREAKPOINT;
    }

    handlePrevNext = (e, cardIndex) => {
        if (this.state.cardIndex > cardIndex) {
            pushEdapEvent('nav.previous.click', {
                actionlocation: this.props.actionlocation,
            });
        } else if (this.state.cardIndex < cardIndex) {
            pushEdapEvent('nav.next.click', {
                actionlocation: this.props.actionlocation,
            });
        }

        this.setState({cardIndex});
    };

    // Toggles prev/next navigation arrows when screen size changes.
    // Always called when ReactCardCarousel mounts & on resize events.
    handleResize = () => {
        const scrolling = this.shouldScrollOnClientRender();
        if (this.state.scrolling !== scrolling) {
            this.setState({scrolling});
        }
    };

    handleActionClick = () => {
        pushEdapEvent('search.link.click', {
            actionlocation: this.props.actionlocation,
        });
    };

    render() {
        const {cardIndex, scrolling} = this.state;
        const {
            cardAspectRatio,
            children,
            carouselBreakpoints,
            title,
            subheading,
            actionHref,
            actionText,
            hasAction,
        } = this.props;

        return (
            <div
                className={classNames('CardCarousel__wrapper', {
                    'CardCarousel__with-destination-subheading': subheading,
                })}
            >
                <ReactCardCarousel
                    paging
                    breakpoints={carouselBreakpoints}
                    scrolling={scrolling}
                    cardIndex={cardIndex}
                    getControlOffset={this.getControlOffset(cardAspectRatio)}
                    onPreviousClick={this.handlePrevNext}
                    onNextClick={this.handlePrevNext}
                    onResize={this.handleResize}
                    onActionClick={this.handleActionClick}
                    title={title}
                    subheading={subheading}
                    actionHref={actionHref}
                    actionText={actionText}
                    actionHrefTarget="_blank"
                >
                    {children}
                </ReactCardCarousel>
                {hasAction && (
                    <a
                        className="CardCarousel__action-bottom"
                        href={actionHref}
                        target="_blank"
                        onClick={this.handleActionClick}
                    >
                        {actionText}
                    </a>
                )}{' '}
            </div>
        );
    }
}

export const Carousel = connect(mapStateToProps)(CarouselComponent);

Carousel.displayName = 'Carousel';

export default Carousel;
